export default __webpack_public_path__ + "static/media/nwfaLarge.a5aae9bb.jpg";